<template>
  <div class="links">
    <router-link class="link" :to="{ name: 'ReceiverHome' }">
      <svg
        style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
        viewBox="0 0 700 512"
        class="link__icon"
      >
        <path
          d="M94 512l512 0 0 -53.42c0,-23.16 -14.78,-43.56 -36.78,-50.77l-136.24 -44.66 0 -48.52 0.33 -0.48c9.77,-14.44 15.92,-31.02 18.11,-48.31l0.21 -1.68 26.04 0c20.21,0 36.65,-16.44 36.65,-36.65l0 -41.31c0,-7.39 -2.21,-14.54 -6.38,-20.64l-0.34 -0.49 0 -7.47c0,-86.9 -70.7,-157.6 -157.6,-157.6 -86.9,0 -157.6,70.7 -157.6,157.6l0 7.47 -0.34 0.49c-4.17,6.1 -6.38,13.25 -6.38,20.64l0 41.31c0,20.21 16.44,36.65 36.65,36.65l26.04 0 0.21 1.68c2.22,17.52 8.51,34.31 18.51,48.89l0.34 0.49 0 47.8 -136.65 44.79c-22,7.21 -36.78,27.61 -36.78,50.77l0 53.42 0 0zm202.78 -168.27c15.93,10.29 34.23,15.81 53.22,15.81 19.15,0 37.6,-5.61 53.62,-16.07l2.96 -1.93 0 25.26 -0.66 0.58c-14.11,12.15 -36.68,26.69 -55.92,26.69 -19.18,0 -41.53,-14.47 -55.52,-26.65l-0.65 -0.57 0 -25.02 2.95 1.9 0 0zm86.76 -213.28l-26.47 0c-1.01,25.97 -22.45,46.78 -48.66,46.78l-34.34 0.01 0 -16.48c0,-41.87 34.06,-75.93 75.93,-75.93 41.87,0 75.93,34.06 75.93,75.93l0 16.11 -2.25 -0.4c-22.54,-4 -39.24,-23.28 -40.14,-46.02zm-14.28 140.23l0 26.39 43.79 0 -2.07 3c-13.95,20.21 -36.2,33.07 -60.98,33.07 -44.03,0 -75.93,-39.07 -75.93,-81.67l0 -47.84 34.34 0c23.89,0 46.17,-11.32 60.36,-30.46l1.54 -2.08 1.54 2.08c12.5,16.86 31.45,27.82 52.36,30.04l1.72 0.18 0 48.08c0,5.94 -0.62,11.86 -1.82,17.68l-0.31 1.53 -54.54 0 0 0zm118.66 -43.17c0,5.66 -4.6,10.25 -10.25,10.25l-25.35 0 0 -61.82 25.35 0c5.65,0 10.25,4.61 10.25,10.26l0 41.31zm-137.92 -201.11c68.42,0 125.62,52.93 130.82,121.12l0.16 2.13 -2.13 -0.07c-0.39,-0.01 -0.79,-0.03 -1.18,-0.03l-25.94 0 -0.22 -1.68c-6.43,-50.98 -50.08,-89.44 -101.51,-89.44 -51.43,0 -95.08,38.46 -101.52,89.44l-0.21 1.68 -25.94 0c-0.39,0 -0.79,0.02 -1.19,0.03l-2.13 0.07 0.17 -2.13c5.2,-68.19 62.4,-121.12 130.82,-121.12l0 0zm-137.92 201.11l0 -41.31c0,-5.65 4.6,-10.26 10.25,-10.26l25.35 0 0 61.82 -25.35 0c-5.65,0 -10.25,-4.6 -10.25,-10.25zm289.86 226.86l-26.4 0 0 31.23 -251.09 0 0 -31.23 -26.39 0 0 31.23 -77.66 0 0 -27.02c0,-11.71 7.48,-22.04 18.6,-25.69l138.42 -45.37 0.81 0.7c19.18,16.35 45.93,32.24 71.77,32.24 25.84,0 52.75,-15.9 72.02,-32.17l0.82 -0.68 138.15 45.28c11.13,3.65 18.61,13.98 18.61,25.69l0 27.02 -77.66 0 0 -31.23 0 0z"
        />
      </svg>
      <span class="link__title" style="position: relative; top: 1px;"
        >پذیرنده ها</span
      >
    </router-link>
    <i class="link__vr"></i>
    <router-link class="link" :to="{ name: 'ProfileEdit' }">
      <svg viewBox="0 0 700 512" class="link__icon">
        <path
          d="M57.73 111.01l-0.04 0.09c-0.11,0.23 -0.22,0.46 -0.31,0.68l-0.02 0.04c-0.02,0.07 -0.04,0.13 -0.06,0.18 -0.17,0.46 -0.32,0.93 -0.45,1.4 -0.04,0.17 -0.08,0.33 -0.13,0.55 -0.05,0.17 -0.07,0.35 -0.1,0.49 -0.04,0.21 -0.07,0.43 -0.1,0.69 -0.02,0.14 -0.04,0.29 -0.05,0.48 -0.04,0.37 -0.02,0.75 -0.03,1.09 0,0.07 0.02,0.15 0.03,0.21l0.02 0.08 0 52.32c0,21.07 17.07,38.69 38.26,38.69l3.03 0 0 290.75c-0.19,7.12 5.53,13.06 12.69,13.24 0.08,0.01 0.16,0.01 0.24,0.01l477.93 0c7.39,0 13.47,-5.85 13.63,-13.24l0 -290.76 3.03 0c21.19,0 38.25,-17.62 38.25,-38.69l0 -52.59c0.02,-0.51 -0.01,-1.03 -0.07,-1.57l-0.01 -0.08c0,-0.06 0,-0.14 -0.02,-0.27 -0.06,-0.47 -0.15,-0.93 -0.26,-1.34 -0.03,-0.11 -0.04,-0.2 -0.06,-0.28 -0.31,-1.08 -0.72,-2.08 -1.27,-3.03 -0.04,-0.05 -0.05,-0.09 -0.08,-0.14l-53.87 -91.19c-6.89,-11.66 -19.45,-18.82 -33,-18.82l-399.89 0c-12.52,0 -24.27,6.11 -31.43,16.37l-64.73 92.74c-0.18,0.26 -0.34,0.49 -0.48,0.72 -0.04,0.07 -0.07,0.11 -0.12,0.21l-0.03 0.05c-0.14,0.24 -0.28,0.48 -0.4,0.72 -0.04,0.08 -0.07,0.14 -0.1,0.2zm37.52 -7.18l50.16 -72.04c2.21,-3.16 5.77,-5.11 9.65,-5.18l399.88 0c4.15,0.07 7.95,2.36 10.05,5.93l42.01 71.29 -511.75 0zm311.52 381.55l-113.5 0 0 -168.54 113.5 0 0 168.54zm168.88 0l-142.26 0 0 -181.69c-0.22,-7.47 -6.26,-13.46 -13.76,-13.46l-139.89 0c-7.3,0.08 -13.16,6.04 -13.08,13.35l0.01 181.8 -142.28 0 0 -277.38 451.26 0 0 277.38zm41.29 -354.93l0 38.86c0,6.53 -5.13,11.9 -11.7,12.08l-510.54 0.01c-6.52,-0.18 -11.59,-5.61 -11.59,-12.09l0 -38.86 533.83 0zm-385.76 164.78l-78.81 0c-7.35,0 -13.31,5.96 -13.31,13.31l0 73.81c0,7.35 5.97,13.3 13.31,13.3l78.81 0c7.35,0 13.3,-5.95 13.3,-13.3l0 -73.81c0,-7.35 -5.95,-13.31 -13.3,-13.31zm-13.31 73.81l-52.2 0 0 -47.19 52.2 0 0 47.19zm328.56 -73.81l-78.81 0c-7.36,0 -13.31,5.96 -13.31,13.31l0 73.81c0,7.35 5.96,13.3 13.31,13.3l78.81 0c7.35,0 13.3,-5.95 13.3,-13.3l0 -73.81c0,-7.35 -5.95,-13.31 -13.3,-13.31zm-13.3 73.81l-52.21 0 0 -47.19 52.21 0 0 47.19z"
        />
      </svg>
      <span class="link__title" style="position: relative; top: 1px;"
        >پروفایل</span
      >
    </router-link>
  </div>
</template>

<style scoped lang="scss">
.links {
  width: calc(94% - 20px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 15px;
  overflow: hidden;
  margin: 20px 0;
  padding: 0 10px;
  height: 140px;
  background-color: #fff;
  // box-shadow: 0 0 20px 1px rgba(#000, 0.1);
}
.link {
  width: 49.5%;
  position: relative;
  z-index: auto;
  border-radius: 15px;
  height: 140px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.link__icon {
  fill: #c69d4e;
  height: 40px;
  width: auto;
  margin-bottom: 10px;
}
.link__title {
  font-size: 13px;
  text-align: center;
  color: #000;
}
.link__vr {
  width: 1px;
  background-color: rgba(0, 0, 0, 0.15);
  height: 60%;
}
</style>
